<template>
  <div class="display-box">
    <div class="img-container" v-if="type === 2 || type === 4">
      <img :src="src" alt="" :style="{transform: `scale(${scaleValue})`}"/>
      <div class="scale-btns">
        <img src="@/assets/images/scale1.png" alt="" class="custom-button" @click="handleScale('small')"/>
        <img src="@/assets/images/scale2.png" alt="" class="custom-button" @click="handleScale('large')"/>
      </div>
    </div>
    <div class="video-container" v-if="type === 3">
      <video :src="videoUrl" controls="controls"></video>
    </div>
    <div class="threed-container" v-if="type === 1">
      <van-loading v-show="loading" class="spin" type="spinner" color="#1989fa"/>
      <div v-show="loadErr" class="error-msg">文件加载失败</div>
      <div ref="threeD" class="threed"></div>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three'
import { DDSLoader } from 'three/examples/jsm/loaders/DDSLoader.js'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

let camera, scene, renderer

let cameraControls

function init (that, objUrl, mtlUrl) {
  objUrl = objUrl || ''
  mtlUrl = mtlUrl || ''
  console.log('objUrl', objUrl)

  const container = document.createElement('div')
  that.$refs.threeD.appendChild(container)

  camera = new THREE.PerspectiveCamera(90, that.$refs.threeD.clientWidth / that.$refs.threeD.clientHeight, 0.1, 2000)
  camera.position.z = 500

  // scene
  scene = new THREE.Scene()

  const ambientLight = new THREE.AmbientLight(0xffffff, 2)
  scene.add(ambientLight)
  // 创建定向光源，参数为十六进制的颜色
  const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5)
  // 指定定向光源由z正半轴射向原点（平行光从屏幕外射向屏幕中心）
  directionalLight.position.set(0, 0, 100)
  scene.add(directionalLight)

  const pointLight = new THREE.PointLight(0xffffff, 0.5)
  camera.add(pointLight)
  scene.add(camera)

  // model

  const onProgress = function (xhr) {
    console.log('onProgress')
    if (xhr.lengthComputable) {
      const percentComplete = xhr.loaded / xhr.total * 100
      console.log(Math.round(percentComplete, 2) + '% downloaded')
      if (percentComplete === 100) {
      }
    }
  }

  const onError = function (err) {
    that.loading = false
    that.loadErr = true
    console.log('onError', err)
  }

  const manager = new THREE.LoadingManager()
  manager.addHandler(/\.dds$/i, new DDSLoader())

  new MTLLoader(manager).load(mtlUrl, function (materials) {
    console.log(materials)
    materials.preload()
    new OBJLoader(manager).setMaterials(materials).load(objUrl, function (object) {
      // console.log('complete obj file', object)
      // if (object.children.length) {
      that.loading = false
      object.children[0].scale.set(0.4, 0.4, 0.4)// 网格模型缩放
      object.children[0].geometry.center()
      // }

      // object.scale.set(0.01, 0.01, 0.01)
      // object.traverse(function (child) {
      //   console.log('traverse中。。。。。', child, child.isMesh)
      //   if (child.isMesh) {
      //     child.material.emissive = child.material.color
      //     child.material.emissiveMap = child.material.map
      //   }
      // })
      scene.add(object)
      // let box = new THREE.Box3().setFromObject( object );
      // let size = box.size();
      // console.log('size', size)
      // object.traverse( function ( child ) {
      // let material = new THREE.MeshPhongMaterial({
      //     // color:0xff0000,
      //     specular:0x4488ee,
      //     shininess:12,
      //     opacity: 0.5,
      //     transparent:true,
      //     map:texture
      // })
      // child.material = material
      // if ( child.isMesh ) {
      //     child.castShadow = true
      //     child.receiveShadow = true
      // }
      // })
      // scene.add(object);
    }, onProgress, onError)
  })

  //

  renderer = new THREE.WebGLRenderer()
  renderer.setPixelRatio(window.devicePixelRatio)
  renderer.setSize(that.$refs.threeD.clientWidth, that.$refs.threeD.clientHeight)
  container.appendChild(renderer.domElement)

  cameraControls = new OrbitControls(camera, renderer.domElement)
  // cameraControls.target.set(0, 50, 0)
  cameraControls.update()
}

function animate () {
  // console.log('animate')
  requestAnimationFrame(animate)
  render()
}

function render () {
  camera.lookAt(scene.position)
  renderer.render(scene, camera)
}

export default {
  name: 'Display',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    src: {
      type: String
    },
    // eslint-disable-next-line vue/require-default-prop
    type: {
      type: Number
    },
    // eslint-disable-next-line vue/require-default-prop
    objUrl: {
      type: String
    },
    // eslint-disable-next-line vue/require-default-prop
    mtlUrl: {
      type: String
    },
    // eslint-disable-next-line vue/require-default-prop
    videoUrl: {
      type: String
    }
  },
  data () {
    return {
      loading: true, // 是否加载中
      loadErr: false, // 是否加载失败
      isComplete: false,
      scaleValue: 1
    }
  },
  mounted () {
    if (this.objUrl) {
      this.$nextTick(() => {
        if (this.type === 1) {
          init(this, this.objUrl, this.mtlUrl)
          animate()
        }
      })
    }
  },
  watch: {
    type: function (val) {
      this.$nextTick(() => {
        if (val === 1) {
          this.loading = true
          init(this, this.objUrl, this.mtlUrl)
          animate()
        }
      })
    }
  },
  methods: {
    handleScale (type) {
      if (type === 'large') {
        this.scaleValue += 0.1
      } else {
        this.scaleValue -= 0.1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.display-box {
  position: relative;
  padding: 47px 80px;
  box-sizing: border-box;
  margin-bottom: 43px;
}

.img-container, .threed-container, .video-container {
  //width: 892px;
  width: 100%;
  max-width: 892px;
  height: 648px;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.video-container > video {
  width: 100%;
  height: 100%;
}

.threed-container > .threed {
  width: 100%;
  height: 100%;
}

.spin {
  position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 10px);
}

.error-msg {
  position: absolute;
  text-align: center;
  color: #ed5050;
  width: 100%;
  background-color: transparent;
  top: calc(50% - 10px);
}

.img-container {
  > img {
    max-width: 892px;
    height: 100%;
    object-fit: contain;
  }

  .scale-btns {
    position: absolute;
    left: 0;
    bottom: 0;

    img {
      width: 50px;
      height: 50px;
      margin-right: 27px;
    }
  }
}
</style>
